module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/bmwtypewebbo_all.ttf?53f5851cf068b8552c2d84bff889a94e";